<script lang="ts" setup>
import { computed } from "vue";
import ButtonSecondary from "~/components/ButtonSecondary.vue";
import type Product from "~~/types/Product";

// Properties
const { product, showButton } = defineProps({
    product: {
        type: Object as PropType<Product>,
        default: null,
    },
    showButton: {
        type: Boolean,
        default: false,
    },
});

// Data
const config = useRuntimeConfig();

const sampleLink = computed(() => {
    const cwResource = product?.cw_resource ?? null;
    if (cwResource && cwResource?.ebook_sample_pages && cwResource.ebook_sample_pages[0]) {
        const pageNum = cwResource.ebook_sample_pages[0];
        return `${config.public.CW_HOST}/samples/resources/${cwResource.id}/preview-eBook?page=${pageNum}`;
    }
    return "";
});
</script>

<template>
    <div class="md:block">
        <ButtonSecondary
            v-show="showButton"
            :type="sampleLink ? 'link' : 'button'"
            :href="sampleLink"
            :disabled="!sampleLink"
            target="_blank"
            class="text-sm"
            py="py-1"
        >
            Look Inside
        </ButtonSecondary>
    </div>
</template>

<style scoped></style>
